var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AdminNav'),_c('UserDirectory',{on:{"dialogClicked":_vm.openDialog}}),_c('AddUser',{attrs:{"dialog":_vm.dialog},on:{"close":_vm.closeDialog}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }